export const convertCurrencyToNumber = (
  currency: string | undefined,
  isDE: boolean = false,
) => {
  if (!currency) return undefined;

  if (isDE) {
    return Number(currency.replace(/[^0-9,-]+/g, '').replace(/,/g, '.'));
  }

  return Number(currency.replace(/[^0-9.-]+/g, ''));
};
